import { brandEntityId, BrandEntityId, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandDeleteVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandDeleteVO.validationSchema()
  );

  constructor(readonly value: RoomBrandDelete) {
    JsonSchemaValidator.assert(RoomBrandDeleteVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId"],
      properties: {
        roomId,
        brandId: brandEntityId
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandDelete {
  roomId: RoomId;
  brandId: BrandEntityId;
}
